import { render, staticRenderFns } from "./LayoutOAuth2.vue?vue&type=template&id=0eafeb30"
import script from "./LayoutOAuth2.vue?vue&type=script&lang=js"
export * from "./LayoutOAuth2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports